import { render } from "./ModalFormRegional.vue?vue&type=template&id=6fd6a2f5&scoped=true"
import script from "./ModalFormRegional.vue?vue&type=script&lang=js"
export * from "./ModalFormRegional.vue?vue&type=script&lang=js"

import "./ModalFormRegional.vue?vue&type=style&index=0&id=6fd6a2f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd6a2f5"]])

export default __exports__